import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CategoriasService } from "src/app/services/categorias.service";
import { StoreService } from "src/app/services/store.service";

@Component({
  selector: "main-header",
  templateUrl: "./main-header.component.html",
  styleUrls: ["./main-header.component.scss"],
})
export class MainHeaderComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  public mobileMenuOpen: boolean = false;

  public categorias: any[] = [];

  public get hasCategorias() {
    return this.categorias && this.categorias.length;
  }

  constructor(
    public _store: StoreService,
    public _categorias: CategoriasService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.getCategorias();
    this.onRouteChanges();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getCategorias() {
    this._categorias.onCategoriasChange$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((categorias) => (this.categorias = categorias));
  }

  onRouteChanges() {
    this.router.events.subscribe(() => {
      this.mobileMenuOpen = false;
    });
  }
}
